import { configureStore } from '@reduxjs/toolkit';
import composerReducer from './slices/composerSlice';
import unreadCountsReducer from './slices/unreadCountsSlice';
import pendingSentEmailsReducer from './slices/pendingSentEmailsSlice';

export const store = configureStore({
    reducer: {
        composer: composerReducer,
        unreadCounts: unreadCountsReducer,
        pendingSentEmails: pendingSentEmailsReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                // Ignore non-serializable values for attachments
                ignoredActions: ['composer/updateComposer'],
                ignoredPaths: ['composer.composers'],
            },
        }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
